import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Button } from 'react-bootstrap';
import { format } from 'date-fns';
import { STATUS } from './Const';
import PropTypes from 'prop-types';

const SpecificDaysPicker = ({
  history,
  userSite,
  displayedDays,
  userHistory,
  isPastDay,
  loading,
  getRemainingSlotCount,
  renderAvailabilityBadge,
  submitOneDay,
  canUserRequest,
  WEEK_AHEAD_COUNT,
  MAX_WEKKLY_REQUEST
}) => {
  const [validHistories, setValidHistories] = useState([]);
  useEffect(() => {
    setValidHistories(
      history.filter(x => x.site == userSite && x.status == STATUS.APPROVED)
    );
  }, [userSite, history]);
  return (
    <Card className="mb-4">
      <Card.Header as="h5" className="bg-white border-bottom">
        2. Or Pick Specific Day(s)
      </Card.Header>

      <Card.Body>
          <Row className="g-3 text-center row-cols-1 row-cols-sm-2 row-cols-md-5">
          {displayedDays.map(d => {
            const dayKey = format(d, 'yyyy-MM-dd');
            const bookings = validHistories.filter(
              x => format(x.bookingDate, 'yyyy-MM-dd') === dayKey
            );

            const hasBookedSlot = bookings.length > 0;
            const disabledBase = isPastDay(d) || loading;

            const isDateRequested =
              userHistory.filter(
                x =>
                  x.bookingDate.toDateString() === d.toDateString() &&
                  (x.status === 'PENDING' || x.status === 'APPROVED')
              )?.length > 0;

            const disabled = disabledBase || isDateRequested;
            const remainingSlot = getRemainingSlotCount(d);
            const fullyBooked = remainingSlot === 0;

            let cardClass =
              !canUserRequest || disabled || fullyBooked
                ? 'bg-light text-muted opacity-75 border-danger'
                : 'shadow-sm border-primary';

            const buttonDisabled = !canUserRequest || disabled || fullyBooked;

            let buttonLabel = 'Request';

            if (fullyBooked) {
              buttonLabel = 'Fully Booked';
            } else if (isDateRequested) {
              buttonLabel = 'Requested';
            }

            return (
                <Col key={dayKey} className="d-flex">
                  <Card className={`w-100 h-100 border ${cardClass}`}>
                    <Card.Body className="d-flex flex-column">
                      <div>
                        <div className="mb-2">
                          <div
                            className={`fw-bold ${
                              disabled ? 'text-muted' : 'text-dark'
                            }`}
                          >
                            {format(d, 'EEE')}
                          </div>
                          <div className="text-muted small">
                            {format(d, 'd MMM')}
                          </div>
                        </div>

                        <div className="mb-3">
                          {renderAvailabilityBadge(d, isDateRequested)}
                        </div>
                      </div>

                      <div className="mt-auto">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => submitOneDay(d)}
                          disabled={buttonDisabled}
                        >
                          {buttonLabel}
                        </Button>
                      </div>

                      <div
                        className="mt-3 border-top pt-2 text-start small"
                        style={{
                          minHeight: '100px',
                          maxHeight: '100px',
                          overflowY: 'auto'
                        }}
                      >
                        {hasBookedSlot && (
                          <>
                            {bookings.map(item => (
                              <div key={item.id} className="mb-1">
                                <strong>{item.bayNo}</strong> -{' '}
                                <strong>{item.slotType}</strong> -{' '}
                                {item.requestedBy}
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
            );
          })}
          </Row>

          {/* ===== NOTE ===== */}
          <Col xs={12} className="mt-4 border-top pt-3">
            <p className="small text-muted mb-0">
              Note: The request for booking space is valid for{' '}
              {WEEK_AHEAD_COUNT} weeks ahead and you only able to book for{' '}
              {MAX_WEKKLY_REQUEST} days/week.
            </p>
          </Col>
      </Card.Body>
    </Card>
  );
};

export default SpecificDaysPicker;

SpecificDaysPicker.propTypes = {
  history: PropTypes.array.isRequired,
  userSite: PropTypes.string.isRequired,
  displayedDays: PropTypes.array.isRequired,
  userHistory: PropTypes.array.isRequired,
  isPastDay: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  getRemainingSlotCount: PropTypes.func.isRequired,
  renderAvailabilityBadge: PropTypes.func.isRequired,
  submitOneDay: PropTypes.func.isRequired,
  canUserRequest: PropTypes.bool.isRequired,
  WEEK_AHEAD_COUNT: PropTypes.number.isRequired,
  MAX_WEKKLY_REQUEST: PropTypes.number.isRequired
};
